import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../../../App'
import axios from 'axios'
import { useMediaQuery } from "react-responsive";

export function useCheckout(actualAddress) {
  const [load, setLoad] = useState(false)
  const [shipment, setShipment] = useState([])
  const [error_shipment, setError_Shipment] = useState('');
  const [error_buy, setError_Buy] = useState('');
  const notMobile = useMediaQuery({ minWidth: 1024 });

  const [openLogin, setOpenLogin] = useState(false);

  const navigate = useNavigate()
  const { user, setUser } = useContext(UserContext)

  const [servicePoints, setServicePoints] = useState([])
  const [address, setAddress] = useState(user?.address)
  const [error_address, setError_Address] = useState('');

  const updateAddress = async (actualAddress = address) => {
    if (typeof actualAddress !== 'undefined' && ('line1' && 'postal_code' && 'city' in actualAddress)) {
      if (actualAddress !== user.address) {
        setLoad(true)
        let values = {
          'address': {
            'line1': actualAddress.line1,
            'postal_code': actualAddress.postal_code,
            'city': actualAddress.city,
          }
        }
        try {
          const response = await axios({
            method: 'post',
            url: '/api/setAddress',
            data: {
                values
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          });

          setUser(response.data);
          setLoad(false)

          return response.data;

        } catch (err) {
          console.log(err)
          return user;
        }
      } else {
        return user;
      }
    } else {
      setError_Address('Indtast din adresse')
    }
  }

  function scrollTo(id) {
    if (id === 'top') {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    } else {
      const element = document.getElementById(id);
      if (element) {
        const offset = 75; // Juster denne værdi til ønsket afstand (100-200px)
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
      }
    }
  }
  
  const handleBuy = async (actualUser = user) => {
    if (!(shipment.some(a => a.deliveryType === 0) || shipment.some(a => a.deliveryType === 2 && !a.pickup.available) || shipment.filter(a => a.deliveryType === 1).some(a => Object.keys(a.service_point).length === 0) || shipment.length === 0)) {
      if (typeof actualUser !== 'undefined') {
        setLoad(true)
        try {
          const response = await axios({
            method: 'post',
            url: '/api/buyBook',
            data: {
              'checkout_data': shipment
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })
          window.location.href = response.data.url
        } catch (error) {
          setOpenLogin(false)
          if (typeof error.response.data.message !== 'undefined') {
            setError_Buy(error.response.data.message)
            if (notMobile) {
              scrollTo('top')
            }
          }
          setLoad(false)
        }
      } else {
        setOpenLogin(true)
      }
    } else {
      shipment.map((ss, index) => {
        if (ss.deliveryType === 1 && Object.keys(ss.service_point).length === 0) {
          scrollTo(`ss_${index}`)
          setError_Shipment("Du skal vælge en pakkeshop")
          return;
        }
      })
    }
  }
  
  const getServicePoints = () => {
    if (typeof address !== 'undefined') {
      axios({
        method: 'post',
        url: '/api/service_points',
        data: {
            'type': "out_delivery",
            'address': {
              'line1': address.line1,
              'postal_code': address.postal_code,
              'city': address.city
            }
        },
        headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(response => {
        setServicePoints(response.data);
      })
      .catch(error => {
        console.log(error);
      });
    }
  }

  return { handleBuy, shipment, setShipment, error_shipment, setError_Shipment, load, setLoad, getServicePoints, servicePoints, address, setAddress, error_address, setError_Address, updateAddress, openLogin, setOpenLogin, error_buy, setError_Buy }
}